import React from 'react';
import './style.css';

function Terms() {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <button onClick={() => window.close()} className="terms-back">
          ← Voltar
        </button>
        
        <h1 className="terms-title">Termos de Uso</h1>
        <p className="terms-updated">Última atualização: 23 de janeiro de 2026</p>
        
        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar o aplicativo ATARIC, você concorda em cumprir e estar vinculado a estes 
              Termos de Uso. Se você não concordar com qualquer parte destes termos, não poderá acessar 
              ou usar nossos serviços.
            </p>
            <p>
              <strong>Para utilizar nossos serviços, você deve ser maior de 18 anos (maior de idade).</strong> 
              Isto se deve à Lei nº 15.211/2025 (Lei Felca / ECA Digital), que estabelece normas 
              protetivas para crianças e adolescentes no ambiente digital. A plataforma ATARIC é 
              destinada exclusivamente a usuários adultos, sendo proibido o cadastro por menores de idade.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Descrição do Serviço</h2>
            <p>
              O ATARIC é uma plataforma de prática de conversação em inglês que utiliza inteligência 
              artificial para ajudar usuários a melhorar suas habilidades de comunicação oral em inglês.
            </p>
            <p>
              Nossos serviços incluem:
            </p>
            <ul>
              <li>Conversação por voz com IA</li>
              <li>Prática de pronúncia</li>
              <li>Feedback em tempo real</li>
              <li>Acompanhamento de progresso</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Cadastro e Conta</h2>
            <p>
              Para utilizar nossos serviços, você deve criar uma conta fornecendo informações 
              verdadeiras, precisas e completas. Você é responsável por manter a confidencialidade 
              de sua senha e por todas as atividades realizadas em sua conta.
            </p>
            <p>
              Você concorda em:
            </p>
            <ul>
              <li>Fornecer informações verdadeiras no cadastro</li>
              <li>Manter suas informações de conta atualizadas</li>
              <li>Não compartilhar sua conta com terceiros</li>
              <li>Notificar-nos imediatamente sobre qualquer uso não autorizado</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Planos e Pagamentos</h2>
            <p>
              O ATARIC oferece planos gratuitos e pagos. Os planos pagos são cobrados de acordo 
              com a periodicidade escolhida (mensal ou anual).
            </p>
            <p>
              <strong>Plano Gratuito:</strong> Permite até 5 minutos de conversa por dia com 
              funcionalidades limitadas.
            </p>
            <p>
              <strong>Planos Pagos:</strong> Oferecem conversas ilimitadas e acesso a todas as 
              funcionalidades da plataforma.
            </p>
            <p>
              Os pagamentos são processados por meio de plataformas de pagamento terceirizadas 
              seguras. Ao assinar um plano pago, você autoriza a cobrança recorrente até o 
              cancelamento.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Cancelamento e Reembolso</h2>
            <p>
              Você pode cancelar sua assinatura a qualquer momento através da plataforma de 
              pagamento. O cancelamento será efetivado ao final do período já pago.
            </p>
            <p>
              Oferecemos garantia de 7 dias para novos assinantes. Se você não estiver satisfeito 
              com o serviço, solicite o reembolso dentro deste período.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Uso Aceitável</h2>
            <p>
              Ao usar o ATARIC, você concorda em não:
            </p>
            <ul>
              <li>Usar o serviço para fins ilegais ou não autorizados</li>
              <li>Tentar acessar áreas restritas do sistema</li>
              <li>Interferir ou interromper o funcionamento do serviço</li>
              <li>Compartilhar conteúdo ofensivo, difamatório ou ilegal</li>
              <li>Usar bots ou scripts automatizados</li>
              <li>Revender ou redistribuir o serviço sem autorização</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>7. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo do ATARIC, incluindo textos, gráficos, logos, ícones, imagens, 
              áudio e software, é de propriedade exclusiva do ATARIC ou de seus licenciadores 
              e está protegido por leis de direitos autorais.
            </p>
            <p>
              Você não pode copiar, modificar, distribuir ou criar obras derivadas sem nossa 
              autorização expressa por escrito.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Privacidade e Dados</h2>
            <p>
              Respeitamos sua privacidade e protegemos seus dados pessoais de acordo com a 
              Lei Geral de Proteção de Dados (LGPD). Coletamos apenas os dados necessários 
              para fornecer nossos serviços.
            </p>
            <p>
              Os dados coletados incluem:
            </p>
            <ul>
              <li>Informações de cadastro (nome, e-mail)</li>
              <li>Dados de uso da plataforma</li>
              <li>Gravações de áudio durante as conversas (processadas em tempo real)</li>
            </ul>
            <p>
              Não vendemos ou compartilhamos seus dados pessoais com terceiros para fins 
              de marketing.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Limitação de Responsabilidade</h2>
            <p>
              O ATARIC é fornecido "como está" e "conforme disponível". Não garantimos que o 
              serviço será ininterrupto, livre de erros ou completamente seguro.
            </p>
            <p>
              Em nenhuma circunstância seremos responsáveis por danos indiretos, incidentais, 
              especiais ou consequenciais decorrentes do uso ou impossibilidade de uso do serviço.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Modificações dos Termos</h2>
            <p>
              Reservamos o direito de modificar estes Termos de Uso a qualquer momento. As 
              alterações entrarão em vigor imediatamente após a publicação. O uso continuado 
              do serviço após as modificações constitui aceitação dos novos termos.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Disposições Gerais</h2>
            <p>
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. 
              Qualquer disputa será resolvida no foro da comarca de São Paulo, SP.
            </p>
            <p>
              Se qualquer disposição destes termos for considerada inválida, as demais 
              disposições permanecerão em pleno vigor.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Contato</h2>
            <p>
              Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <p>
              <strong>E-mail:</strong> contato@ataric.com.br
            </p>
          </section>
        </div>

        <div className="terms-footer">
          <button 
            onClick={() => window.close()} 
            className="terms-back-button"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Terms;

